module.exports = require("./mgh-MZ");